exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-upload-list--picture-card .el-upload-list__item-status-label {\n  width: 90px !important;\n  height: 43px !important;\n  position: absolute;\n  right: -32px;\n  top: -4px;\n}\n.el-icon-check {\n  font-size: 27px !important;\n}\n", ""]);

// exports
